
import { SMSorEmailCommunicationType } from '../../Enums/FormEnums';
import {checkWindowFunctionWithArgs} from '../Models/CommonItemsModel'; 
export interface IPatientFaxQueueInputs
{
    patientId?: number,
    startDate?: string,
    endDate?: string,
    viewFaxed: boolean
}

export interface IPatientFaxQueueItem {
    fax_queue_id: number,
    fax_queue_type: string,
    fax_queue_display: string,
    faxed: boolean,
    posted_date: string,
    fax_queue_identifier: number,
    fax_queue_identifier_2?: number,
    faxed_date?: string,
    faxed_by?: string,
    fax_size: string,
    selected?: boolean
}

export interface IPatientPrintFaxQueueInitialize {
    faxEnabled: number,
    faxActive: number,
    faxList?:  Array<IPatientFaxQueueItem>,
    printList?:  Array<IPatientPrintQueueItem>,
    patientName?: string
}

export interface IPatientFaxQueueResults {
    faxList:  Array<IPatientFaxQueueItem>
}

export interface IPatientFaxQueueDeleteItem {
    faxQueueId: number
}
export interface IPatientFaxQueueDeleteInputs {
    patientId: number,
    faxList:  Array<IPatientFaxQueueDeleteItem>
}

export interface IPatientFaxQueueSentInputs {
    patientId: number,
    faxQueueList: number[]
}

export enum PrintQueueType {
    ClinicalSummary = 1,
    MMLWelcomeLetter = 2,
    PDF = 3,
    ActiveReport = 4
}

export interface IPatientPrintQueueItem {
    action_group_item_id: number,
    encounter_id: number,
    encounter_display: string,
    faxed: boolean,
    action_code: number,
    action_type: string,
    action_alias: string,
    action_data: string,
    log_name?: string,
    log_date?: string,
    encounter_table: string,
    print_queue_item: boolean,
    print_queue_type_id: PrintQueueType,
    selected?: boolean
}

export interface IPatientPrintQueueResults {
    printList:  Array<IPatientPrintQueueItem>
}

export interface IPatientPrintQueueInputs
{
    patientId?: number,
    startDate?: string,
    endDate?: string,
    viewPrinted: boolean
}

export interface IPatientPrintQueueAddClinicalSummaryInputs
{
    patientId?: number,
    appointmentId?: number
}

export interface IPatientPrintQueueUpdateClinicalSummaryItem {
    printQueueId: number
}

export interface IPatientPrintQueueUpdateClinicalSummaryInputs
{
    patientId: number,
    clinicalSummaryList:  Array<IPatientPrintQueueUpdateClinicalSummaryItem>
}

export interface IPatientPrintQueueGetClinicalSummaryInputs
{
    patientId: number,
    printQueueId: number
}

export interface IPatientPrintQueueGetClinicalSummaryResults {
    passed: boolean,
    message?: string,
    ccdHtml?: string,
    ccdXml?: string
}

export interface IPatientPrintQueueDeleteItem {
    printQueueId: number
}
export interface IPatientPrintQueueDeleteInputs {
    patientId: number,
    deleteList:  Array<IPatientPrintQueueDeleteItem>
}

export interface IPatientCreateQuickInputs {
    firstName: string,
    middleName?: string,
    lastName: string,
    dateOfBirth: string,
    gender: string,
    phoneHome?: string,
    phoneHomeExt?: string,
    phoneWork?: string,
    phoneWorkExt?: string,
    phoneOther?: string,
    phoneOtherExt?: string,
    sameAsPatient: boolean,
    bypassUnique: boolean
}

export interface IPatientCreateQuickResult {
    passed: boolean,
    message?: string,
    duplicate: boolean,
    patientId?: number
}

export interface IPatientDemographicsResult {
    patientId: number,
    patientEid: number,
    firstName?: string,
    middleName?: string,
    lastName?: string,
    nameSuffix?: string,
    nickName?: string,
    patientName: string,
    genderCode?: string,
    genderDesc?: string,
    ethnicityId?: number,
    ethnicityDesc?: string,
    email?: string,
    phoneHome?: string,
    phoneHomeExt?: string,
    phoneWork?: string,
    phoneWorkExt?: string,
    phoneOther?: string,
    phoneOtherExt?: string,
    address1?: string,
    address2?: string,
    city?: string,
    state?: string,
    zipCode?: string,
    birthDate?: string
}
export interface IPatientServicePatientHeaderResponse {
    patientId: number,
    patientEid: number,
    patientName: string,
    birthDate?: string,
    patientAge?: string,
    genderCode?: string,
    genderDescription?: string
}

export interface IPatientServiceAlertItem {
    src: string,
    msg: string
}

export interface IPatientServiceValidationResult {
    validationMessage?: string,
    validationExits: boolean
}

export interface IPatientTouchInputs {
    Id: number, 
    EntityId: number,
    Name: string,
    Birthdate?: string, 
    Gender?: string
}

export interface IPatientTouchInputsResponse {
    passed: boolean 
}
export interface IPatientTouchInputsResult {
    Id: number, 
    EntityId: number,
    Name: string,
    BirthDate?: string, 
    Gender?: string,
    TouchPointDateTime?: string
}

export enum PatientBalanceType {
    Patient = 1,
    Insurance = 2,
    Unsubmitted = 3
}

export interface IPatientBalanceItem {
    balanceType: PatientBalanceType,
    agingPeriod: number,
    totalBalance: number,
    label1?: string,
    balance1: number,
    label2?: string,
    balance2: number,
    label3?: string,
    balance3: number,
    label4?: string,
    balance4: number,
    label5?: string,
    balance5: number,
    label6?: string,
    balance6: number,
    label7?: string,
    balance7: number,
    label8?: string,
    balance8: number
}

export interface IPatientEnhancedAccessItem {
    usersId: string,
    accessDate: string,
    accessCount: number
}

export interface IReceiptPrefernce {
    type: SMSorEmailCommunicationType,
    overrideValue: string
}

export function UpdateTitleBar(patientID: number, patientName: string, patientDOB: string) {
    const title_function = checkWindowFunctionWithArgs<() => void>('SetClaimSelectTitle',false);
    if (title_function) { 
        title_function(patientID,patientName,patientDOB);
    }    
}